import { render, staticRenderFns } from "./CenterRightReviewps.vue?vue&type=template&id=949aac4e&scoped=true"
import script from "./CenterRightReviewps.vue?vue&type=script&lang=js"
export * from "./CenterRightReviewps.vue?vue&type=script&lang=js"
import style0 from "./CenterRightReviewps.vue?vue&type=style&index=0&id=949aac4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949aac4e",
  null
  
)

export default component.exports